/** Sites tab for the Customer Workspace (Demo Mode only). Manages customer sites, regions,
 * service models, go-live dates, site onboarding status and site-specific requirements - see
 * `../../../../mocks/data/customerManagementData.ts`. */

import {
  Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Section } from '../../../../components/ui/Section';
import { TableHeader } from '../../../../components/forms/TableHeader';
import { Pill } from '../../../../components/shared/Pill';
import { CustomerRecord } from '../../../../mocks/data/customerManagementData';

interface SitesTabProps {
  customer: CustomerRecord;
}

const SitesTab = ({ customer }: SitesTabProps) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <Section>
      <TableHeader>
        {t('sitesTableTitle', 'Locations')}
        <Pill text={`${customer.sites.length} ${t('sitesCountLabel', 'locations')}`} />
      </TableHeader>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('sitesSite', 'Location')}</TableCell>
              <TableCell>{t('sitesRegion', 'Region')}</TableCell>
              <TableCell>{t('sitesServiceModel', 'Service Model')}</TableCell>
              <TableCell>{t('sitesGoLiveDate', 'Go-Live Date')}</TableCell>
              <TableCell>{t('sitesHeadcount', 'Headcount')}</TableCell>
              <TableCell>{t('sitesRequirements', 'Requirements')}</TableCell>
              <TableCell>{t('sitesStatus', 'Status')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {customer.sites.map((site) => (
              <TableRow key={site.site}
                hover
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate('/estate-management/sites')}>
                <TableCell>{site.site}</TableCell>
                <TableCell>{site.region}</TableCell>
                <TableCell>{site.serviceModel}</TableCell>
                <TableCell>{site.goLiveDate}</TableCell>
                <TableCell>{site.headcount}</TableCell>
                <TableCell>{site.requirements}</TableCell>
                <TableCell>
                  <Chip label={site.status}
                    size="small"
                    color={site.status === 'Live' ? 'success' : site.status === 'Mobilising' ? 'warning' : 'default'}
                    variant="outlined" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Section>
  );
};

export default SitesTab;
